const scrollToRef = (ref: React.RefObject<HTMLDivElement>): void => {
  ref.current && window.scrollTo(0, ref.current.offsetTop);
};

export {scrollToRef};
export default scrollToRef;
